import React from 'react';
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import CategoryIcon from '@mui/icons-material/Category';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import ImageIcon from '@mui/icons-material/Image';
import LayersIcon from '@mui/icons-material/Layers';
import PreviewIcon from '@mui/icons-material/Preview';
import BuildIcon from '@mui/icons-material/Build';

export type PdfPanelId = 'templates' | 'elements' | 'text' | 'assets' | 'layers' | 'preview' | 'tools';

interface PdfPanelRailProps {
  activePanel: PdfPanelId;
  onChange: (panel: PdfPanelId) => void;
}

const PANEL_ITEMS: Array<{ id: PdfPanelId; label: string; icon: React.ReactNode }> = [
  { id: 'templates', label: 'Mallar', icon: <ViewModuleIcon fontSize="small" /> },
  { id: 'elements', label: 'Element', icon: <CategoryIcon fontSize="small" /> },
  { id: 'text', label: 'Text', icon: <TextFieldsIcon fontSize="small" /> },
  { id: 'assets', label: 'Bilder', icon: <ImageIcon fontSize="small" /> },
  { id: 'layers', label: 'Lager', icon: <LayersIcon fontSize="small" /> },
  { id: 'preview', label: 'Preview', icon: <PreviewIcon fontSize="small" /> },
  { id: 'tools', label: 'Verktyg', icon: <BuildIcon fontSize="small" /> },
];

const PdfPanelRail: React.FC<PdfPanelRailProps> = ({ activePanel, onChange }) => {
  return (
    <Box
      sx={{
        width: 62,
        flexShrink: 0,
        borderRight: '1px solid rgba(15, 23, 42, 0.08)',
        pr: 0.75,
        mr: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      {PANEL_ITEMS.map((item) => {
        const selected = activePanel === item.id;
        return (
          <Tooltip key={item.id} title={item.label} placement="left">
            <Box
              component="button"
              type="button"
              onClick={() => onChange(item.id)}
              sx={{
                width: 50,
                minHeight: 54,
                border: 0,
                borderRadius: 2,
                backgroundColor: selected ? 'rgba(126, 63, 242, 0.12)' : 'transparent',
                color: selected ? '#6d28d9' : 'text.secondary',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.25,
                '&:hover': {
                  backgroundColor: selected ? 'rgba(126, 63, 242, 0.16)' : 'rgba(15, 23, 42, 0.06)',
                },
              }}
            >
              <IconButton
                component="span"
                size="small"
                disableRipple
                sx={{ color: 'inherit', p: 0.25 }}
              >
                {item.icon}
              </IconButton>
              <Typography
                variant="caption"
                component="span"
                sx={{ fontSize: 10, fontWeight: selected ? 700 : 600, lineHeight: 1.1 }}
              >
                {item.label}
              </Typography>
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default PdfPanelRail;
